import { Injectable, inject } from '@angular/core';
import type { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { tap, combineLatest, of, switchMap } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { DepartmentActions, DepartmentSelectors } from '@core/department-data';
import { JobsWrapperDataService } from '@core/offers-data';
import { RequisitionsScope } from '@core/requisitions-types';
import {
  RequisitionsActions,
  RequisitionsFilterCountersActions,
} from '@recruitee/requisitions-data';
import {
  RequisitionsConfigActions,
  RequisitionsFlowsActions,
} from '@recruitee/requisitions-settings-data';

@Injectable()
export class RequisitionsListResolver {
  private readonly jobsWrapperDataService = inject(JobsWrapperDataService);
  private readonly store = inject(Store);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.store.dispatch(RequisitionsConfigActions.fetch());
    this.store.dispatch(RequisitionsFlowsActions.fetchCollection());
    this.store.dispatch(DepartmentActions.fetchCollection());
    this.store.dispatch(RequisitionsFilterCountersActions.fetch());

    return combineLatest([
      this.jobsWrapperDataService.getJobItems$().pipe(filterBoolean),
      this.store.select(DepartmentSelectors.isLoaded()).pipe(filterBoolean),
    ]).pipe(
      tap(() =>
        this.store.dispatch(
          RequisitionsActions.fetchCollection({ payload: { scope: RequisitionsScope.Active } }),
        ),
      ),
      switchMap(() => of(true)),
    );
  }
}
